<template>
  <div class="container-fluid">
    <div
      class="d-flex flex-wrap flex-column flex-sm-row mb-3 justify-content-between"
    >
      <div class="">
        <div class="d-flex align-items-center">
          <!-- <div class="border rounded p-1 mr-4 cursor-pointer" @click="goBack">
            <el-icon :size="20" class="d-flex"><ArrowLeft /></el-icon>
          </div> -->
          <div class="s-32 font-weight-bold text-head text-black">
            Individual Asset Overview
          </div>
        </div>
        <BackRoute />
      </div>
      <div class="d-flex flex-column flex-sm-row link">
        <router-link class="" :to="`/tenant/asset/create?id=${route.query.id}`">
          <el-button
            :color="primarycolor"
            class="header-btn w-100 mt-3 mt-sm-0"
            round
          >
            Edit Asset
          </el-button></router-link
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 px-0">
        <IndOverviewSum :data="assetForm" />
      </div>
      <div class="col-md-12">
        <AssetInformation :data="assetForm" />
      </div>
      <div class="col-md-12 mt-4">
        <MainttennaceSch :data="maintenanceData" />
      </div>
      <div class="container-fluid">
        <div
          class="col-md-12 mt-4 p-5 bg-light2 border-radius-8 border-brown-300 border-radius"
        >
          <div
            class="col-md-12 py-4 px-3 border-radius-8 bg-white"
            style="border: 1px solid #d9d9d9"
          >
            <TableNoExport2
              :data="filteredData"
              :headers="maintenanceHeaders"
              @update:searchText="handleSearchTextUpdate"
              :checkMultipleItem="false"
              :filterItem="false"
            >
              <template v-slot:maintenanceDate="{ item }">
                <div class="fw-400">
                  {{ date(item.maintenanceDate) }}
                </div>
              </template>
              <template v-slot:details="{ item }">
                <div class="fw-400">{{ item.details }}</div>
              </template>
              <template v-slot:cost="{ item }">
                <div class="fw-400">
                  {{ item.cost.toLocaleString() || "" }}
                </div>
              </template>
              <template v-slot:maintenanceAgent="{ item }">
                <div class="fw-400">{{ item.maintenanceAgent }}</div>
              </template>
              <template v-slot:scheduledDate="{ item }">
                <div class="fw-400">
                  {{ date(item.scheduledDate) }}
                </div>
              </template>
              <template v-slot:status="{ item }">
                <div class="c-pointer fw-400">
                  {{ maintenanceStatus[item.status] }}
                </div>
              </template>

              <template v-slot:action="{ item }">
                <el-dropdown trigger="click">
                  <el-icon><MoreFilled /></el-icon>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="deleteMaintenance(item.id)">
                        Delete
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </TableNoExport2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, inject, computed, onMounted } from "vue";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import TableNoExport2 from "../../../components/table/TableNoExport2.vue";
import IndOverviewSum from "./IndOverviewSum.vue";
import AssetInformation from "./AssetInformation.vue";
import MainttennaceSch from "./MainttennaceSch.vue";
import assetService from "../../../services/asset/assetServices";
import monthDayYear from "../../../services/dates/dateformatter";
import { useRoute } from "vue-router";

const primarycolor = inject("primarycolor");
const searchText = ref("");
const textHead = ref("Asset Maintenance History");
const maintenanceStatus = ["Scheduled", "InProgress", "Completed", "Cancelled"];

const maintenanceHeaders = ref([
  { name: "Date", value: "maintenanceDate" },
  { name: "DETAILS", value: "details" },
  { name: "COST", value: "cost" },
  { name: "Company/Person", value: "maintenanceAgent" },
  { name: "Next Schedule", value: "scheduledDate" },
  { name: "SATUS", value: "status" },
  { name: "Action", value: "action" },
]);

const maintenanceData = ref([]);
const assetForm = ref({});
const route = useRoute();
const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};

const getAssetById = async () => {
  try {
    const response = await assetService.getAssetById(route.query.id);
    console.log(response, "single assest");
    assetForm.value = response;
  } catch (error) {}
};
getAssetById();

const deleteMaintenance = async (id) => {
  try {
    await ElMessageBox.confirm(
      "Are you sure you want to delete this record?",
      "Confirm delete",
      {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }
    );
    await assetService.deleteMaintenance(id);
    ElNotification({ type: "success", message: "Deleted successfully" });
    fetchMaintenanceData();
  } catch (error) {
    console.error("Delete error:", error);
  }
};

// Fetch maintenance records for this asset
const fetchMaintenanceData = async () => {
  try {
    const response = await assetService.getMaintenance();
    maintenanceData.value = response;
  } catch (error) {
    console.error("Error fetching maintenance data:", error);
  }
};

const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};

const filteredData = computed(() => {
  if (!searchText.value.trim()) {
    return maintenanceData.value;
  }
  return maintenanceData.value.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.value.toLowerCase())
  );
});

onMounted(fetchMaintenanceData);
</script>

<style scoped>
.bg-light2 {
  background-color: #edf4ff;
}
</style>
